import {
  InstrumentStatus,
  type PaymentInstrument,
  PaymentModuleId,
} from '@foundation/apis/payments';
import { useTranslation } from '@shared/localization';
import { useMemo } from 'react';

import { FilledBadge, Paragraph, PaymentIcon } from '@/components/common';
import { BadgeType } from '@/components/common/badges/enums';
import { useUserFriendlyPrefixForInstrumentBrand } from '@/hooks/useUserFriendlyPrefixForInstrumentBrands';

export function StoredInstrument(instrument: PaymentInstrument) {
  const { t } = useTranslation();
  const instrumentBrandPrefixer = useUserFriendlyPrefixForInstrumentBrand();

  const instrumentName = useMemo(() => {
    if (instrument.brand) {
      const brandPrefix = instrumentBrandPrefixer(instrument.brand) ?? '';

      if (instrument.moduleId === PaymentModuleId.BraintreeGooglePay) {
        const googlePayString = 'Google Pay';
        return `${googlePayString} (${brandPrefix ?? ''} ${
          instrument.maskedInfo
        })`;
      }

      return `${brandPrefix ?? ''} ${instrument.maskedInfo}`;
    }

    return instrument.maskedInfo;
  }, [instrument, instrumentBrandPrefixer]);

  return (
    <div className={'w-full'}>
      <div className={'w-full flex flex-row items-center space-x-sm'}>
        <PaymentIcon icon={instrument.iconName} />
        <div className="flex flex-row w-full justify-between items-center">
          <div
            className="grid"
            title={instrumentName}
          >
            <Paragraph ellipsisOnOverflow>{instrumentName}</Paragraph>
            <div className="flex items-center gap-3">
              {instrument.expirationDate && (
                <div className="grow-0 shrink-0 w-14 text-sm text-silver">
                  <Paragraph ellipsisOnOverflow>
                    {instrument.expirationDate}
                  </Paragraph>
                </div>
              )}
              {instrument.status === InstrumentStatus.Expired && (
                <FilledBadge
                  type={BadgeType.Error}
                  text={t('Expired')}
                />
              )}
              {instrument.status ===
                InstrumentStatus.TemporarilyUnavailable && (
                <FilledBadge
                  type={BadgeType.Info}
                  text={t('Unavailable')}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
